// extracted by mini-css-extract-plugin
module.exports = {"bidLine":"BidCard_bidLine__1ZHmA","container":"BidCard_container__2jVGR","image":"BidCard_image__1xcVu","left":"BidCard_left__7b_QE","right":"BidCard_right__10jz7"};